import styled from 'styled-components';
import { Button, Subtitle, TrevorIcon } from '@trevor/ui-components';
import React, { FC } from 'react';
import { DataSourceList } from '@/containers/DatasourcesPage/components/DatasourceList';

const DatasourceListSectionConnectDatabaseButton = styled(Button).attrs({
  icon: <TrevorIcon name="plus" />,
  size: 'large',
})`
  margin-top: var(--spacing-l);
`;

const DatasourceListSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  > p {
    margin-bottom: var(--spacing-l);
  }

  > button {
    margin-top: 48px;
  }
`;

type DatasourceListSectionProps = {
  email: Maybe<string>;
  numberOfDatasources: Maybe<number>;
  onConnectDatabase: F0;
  showConnectButton: boolean;
};
export const DatasourceListSection: FC<DatasourceListSectionProps> = ({
  email,
  numberOfDatasources,
  onConnectDatabase,
  showConnectButton,
}) => {
  return (
    <DatasourceListSectionContainer>
      <Subtitle variant={1}>
        Datasources for&nbsp;
        <b>
          {email} ({numberOfDatasources})
        </b>
      </Subtitle>
      <DataSourceList />
      {showConnectButton && (
        <DatasourceListSectionConnectDatabaseButton onClick={onConnectDatabase}>
          Connect a database
        </DatasourceListSectionConnectDatabaseButton>
      )}
    </DatasourceListSectionContainer>
  );
};
